<template>
	<div>
		<dropdown class="full-width" :maxHeight="250">
			<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default full-width" data-toggle="dropdown">
				{{ passedFont.family }}
				<i class="fa fa-angle-down pull-right"></i>
			</button>
			<ul slot="dropdown-menu" class="dropdown-menu full-width">
				<template v-for="font in allGoogleFonts">
					<li>
						<a @click="emitFontFamily(font)">{{ font.family }}</a>
					</li>
				</template>
			</ul>
		</dropdown>
	</div>
</template>
<script>
import Dropdown from './Dropdown'
import { mapActions, mapGetters } from 'vuex'

/**
 * Font picker module is used to pull the list of font options and display them in a dropdown.
 * @class FontPicker
 * @prop {object} passedFont - Used the pass the currently selected font.
 * @since 0.0.9
 */

export default {
	name: 'font-picker',
	props: {
		passedFont: {
			default: {}
		}
	},
	/**
	 * Run on created to check if the fonts have already been pulled in and to assign a default font.
	 * @function
	 * @returns {undefined}
	 * @memberof FontPicker
	 * @version 0.0.9
	 */
	created () {
		if (!this.allGoogleFonts.length) {
			this.getGoogleFonts().then(() => {
				if (!this.passedFont.family) {
					this.setOpenSans()
				}
			})
		} else {
			if (!this.passedFont.family) {
				this.setOpenSans()
			}
		}
	},
	computed: mapGetters([
		'allGoogleFonts'
	]),
	methods: {
		/**
		 * To parse through all fonts to find Open Sans and set it as the active font.
		 * @function
		 * @returns {undefined}
		 * @memberof FontPicker
		 * @version 0.0.9
		 */
		setOpenSans () {
			let minIndex = 0
			let maxIndex = this.allGoogleFonts.length
			let currentIndex

			while (minIndex <= maxIndex) {
				currentIndex = (minIndex + maxIndex) / 2 | 0

				let currentName = this.allGoogleFonts[currentIndex].family
				if (currentName === 'Open Sans') {
					this.emitFontFamily(this.allGoogleFonts[currentIndex])
					break
				} else if (currentName < 'Open Sans') {
					minIndex = currentIndex + 1
				} else if (currentName > 'Open Sans') {
					maxIndex = currentIndex - 1
				}
			}
		},
		/**
		 * To emit the selected font to the parent component.
		 * @function
		 * @param {object} font - The font that is being selected.
		 * @returns {undefined}
		 * @memberof FontPicker
		 * @version 0.0.9
		 */
		emitFontFamily (font) {
			this.$emit('updateFont', font)
		},
		...mapActions([
			'getGoogleFonts'
		])
	},
	components: {
		Dropdown
	}
}
</script>



// WEBPACK FOOTER //
// FontPicker.vue?239cb9c9